import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { IGenre, IMedia, IPagination, EPeriod, ELanguage } from '../interfaces';
import Axios, { AxiosResponse } from 'axios';
import config from '../config';
import Pagination from '../components/common/Pagination';
import { connect } from 'react-redux';
import Favorite from '../components/parts/Favorite';
import { transliterate } from '../utils/functions';
import { withTranslation } from 'react-i18next';
import i18n from '../config/i18next';

let russian = [ "А", "Б", "В", "Г", "Д", "Е", "Ё", "Ж", "З", "И", "К", "Л", "М", "Н", "О", "П", "Р", "С", "Т", "У", "Ф", "Х", "Ц", "Ч", "Ш", "Щ", "Э", "Ю", "Я" ];
let latin = [ "A", "B", "C", "Ch", "D", "E", "F", "G", "G'", "H", "I", "J", "K", "L", "M", "N", "O", "O'", "P", "Q", "R", "S", "Sh", "T", "U", "V", "W", "X", "Y", "Z", "0-9" ];

const CancelToken = Axios.CancelToken;
let cancel: any;

interface IState {
    genres: IGenre[],
    tracks: IMedia[],
    isLoading: boolean,
    isPopularLoading: boolean,
    currentPage: number,
    totalPages: number,
    pages: IPagination,
    letter: string,
    language: ELanguage,
    popularTracks: IMedia[],
    period: EPeriod,
    genre_id: number,
    showMore: boolean
}

class Festival extends React.Component<any, IState> {
    private _isUnmounted: boolean = false;

    constructor(props: any) {
        super(props);

        this.state = {
            genres: [],
            tracks: [],
            isLoading: true,
            isPopularLoading: true,
            currentPage: 1,
            totalPages: 1,
            pages: null,
            letter: "",
            language: null,
            popularTracks: [],
            period: EPeriod.DAY,
            genre_id: this.props.match.params.genre_id,
            showMore: false
        };

        this.onPageChange = this.onPageChange.bind(this);
    }

    componentDidMount() {
        this.loadTracks();
        this.loadGenres();
        this.loadPopularTracks();
    }

    async loadGenres (){
        let response: AxiosResponse = await Axios.get(`${config.site}/${i18n.language}/api/stat/festival-genre`);
        console.log(response.data);
        
        if (!this._isUnmounted)
            this.setState({
                genres: response.data ? response.data : []
            });
    }

    async loadTracks (){
        cancel && cancel();

        try {
            let response: AxiosResponse = await Axios.get(`${config.site}/${i18n.language}/api/festival/list?letter=${this.state.letter}` + (this.state.pages ? `&${this.state.pages.pageParam}=${this.state.currentPage}` : ``) + (this.state.genre_id ? `&genre_id=${this.state.genre_id}` : ``) + (this.state.language ? `&language=${this.state.language}` : ``), {
                cancelToken: new CancelToken(function executor (c) {
                    cancel = c;
                })
            });
    
            let {data} = response;
            
            let totalPages = response.data.pages.pageCount;
            
            if (!this._isUnmounted)
                this.setState({
                    tracks: data.tracks,
                    isLoading: false,
                    pages: data.pages,
                    totalPages: totalPages,
                    currentPage: totalPages > 0 ? this.state.currentPage : 0
                });
        } catch (err) {

        }
        
    }

    async loadPopularTracks (){
        let response: AxiosResponse = await Axios.get(`${config.site}/${i18n.language}/api/festival/popular-list?filter=${this.state.period}`);

        let {data} = response;

        if (!this._isUnmounted)
            this.setState({
                popularTracks: data,
                isPopularLoading: false
            });
    }

    changeLetter(letter: string) {
        this.setState({
            letter,
            isLoading: true,
            currentPage: 1
        }, this.loadTracks);
    }

    componentWillUnmount() {
        this._isUnmounted = true;
    }

    onPageChange(page: number) {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });

        this.setState({
            currentPage: page,
            isLoading: true,
            // films: []
        }, async () => {
            await this.loadTracks();

        });
    }

    
    onGenreChange(genre_id: number) {
        this.setState({
            genre_id: genre_id,
            isLoading: true,
        }, async () => {
            await this.loadTracks();
        });
    }

    onLanguageChange(language: ELanguage) {
        this.setState({
            language,
            isLoading: true,
        }, async () => {
            await this.loadTracks();
        });
    }

    onChangePeriod(period: EPeriod) {
        this.setState({
            period,
            isPopularLoading: true
        }, this.loadPopularTracks);
    }

    render() {
        const {t} = this.props;

        let currentGenre = this.state.genres.find((genre: IGenre) => genre.genre_id == this.state.genre_id);

        return (
            <div className="i-body">
                <div className="container login-page v-index">
                    <div className="wrapper">
                        <div className="row">
                            <div className="col-md-8 col-xs-12">
                                <ul className="submenu">
                                    <li className=""><NavLink to="/concerts">{t("Концерты")}</NavLink></li>
                                    <li className="active"><NavLink to="/festivals">{t("Фестивали")}</NavLink></li>
                                </ul>
                                <div className="wrap">
                                    <div className="filter_box filter_box_music">
                                        <form id="filter-form" action="/ru/videoclub/filter" method="GET">
                                            <div className="filter">
                                                <button className="change_ganre" type="button">{currentGenre ? currentGenre.name : t("Все жарны")} </button>
                                                <div className="change_box">
                                                    <div key={9999} className="radio_box">
                                                        <input type="radio" id="g" value="" />
                                                        <label onClick={(event: React.MouseEvent) => {
                                                            this.onGenreChange(null);
                                                        }} htmlFor="g">{t("Все жарны")}</label>
                                                    </div>
                                                    {this.state.genres.map((genre: IGenre, index: number) => {
                                                        return <div key={index} className="radio_box">
                                                            <input type="radio" id={"g" + genre.genre_id} value={genre.genre_id} />
                                                            <label onClick={(event: React.MouseEvent) => {
                                                                this.onGenreChange(genre.genre_id);
                                                            }} htmlFor={"g" + genre.genre_id}>{genre.name}</label>
                                                        </div>
                                                    })}
                                                </div>
                                            </div>
                                            <div className="filter">
                                                <button className="change_ganre" type="button">{t("Фильтр")}</button>
                                                <div className="change_box">
                                                    <div className="radio_box">
                                                        <input type="radio" id="y1" value="1" />
                                                        <label onClick={() => {
                                                            this.onLanguageChange(null);
                                                        }} htmlFor="y2019">{t("Все")}</label>
                                                    </div>
                                                    <div className="radio_box">
                                                        <input type="radio" id="y2" value="2" />
                                                        <label onClick={() => {
                                                            this.onLanguageChange(ELanguage.UZBEK);
                                                        }} htmlFor="y2">{t("Узбекские")}</label>
                                                    </div>
                                                    <div className="radio_box">
                                                        <input type="radio" id="y3" value="3" />
                                                        <label onClick={() => {
                                                            this.onLanguageChange(ELanguage.RUSSIAN);
                                                        }} htmlFor="y3">{t("Русские")}</label>
                                                    </div>
                                                    <div className="radio_box">
                                                        <input type="radio" id="y4" value="4" />
                                                        <label onClick={() => {
                                                            this.onLanguageChange(ELanguage.OTHER);
                                                        }} htmlFor="y4">{t("Зарубежные")}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <ul className="alfa">
                                        <li key={99999}><a onClick={(event: React.MouseEvent) => {
                                            event.preventDefault();

                                            this.changeLetter("");
                                        }}>{this.state.letter == "" ? <b>{t("Все")}</b> : t("Все")}</a></li>
                                        {russian.map((letter: string, index: number) => {
                                            return (<li key={index}><a onClick={(event: React.MouseEvent) => {
                                                event.preventDefault();

                                                this.changeLetter(letter);
                                            }}>{letter == this.state.letter ? <b>{letter}</b> : letter}</a></li>);
                                        })}
                                        
                                    </ul>

                                    <ul className="alfa lat">
                                        {latin.map ((letter: string, index: number) => {
                                            return (<li key={index}><a onClick={(event: React.MouseEvent) => {
                                                event.preventDefault();

                                                this.changeLetter(letter);
                                            }}>{letter == this.state.letter ? <b>{letter}</b> : letter}</a></li>);
                                        })}
                                    </ul>

                                    {this.state.isLoading && <div className="carousel-placeholder"/>}
                                    {!this.state.isLoading && this.state.tracks.length == 0 && <h5 className="text-center mt-20">{t("Ничего не найдено")}</h5>}

                                    <div className="box_list clips_list">
                                        <div className="row">
                                            {!this.state.isLoading && this.state.tracks.map ((track: IMedia, index: number) => {
                                                return (
                                                    <div key={index} className="col-md-4 col-sm-6 col-xs-6">
                                                        <div className="item">
                                                            <div className="img_box">
                                                                <div className="icons">
                                                                    <ul>
                                                                        <li>
                                                                            <Favorite media={track}/>
                                                                        </li>
                                                                        <li>
                                                                            <span> </span>
                                                                            <NavLink to={"/festival/" + transliterate((track.artist ? track.artist.full  + "-" : "") + track.name) + "/" + track.media_id}>
                                                                                <i className="fa fa-play-circle-o"></i>
                                                                            </NavLink>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                <img style={{width: "100%", height: "100%"}} src={track.fullFirstFrame} alt={track.name}/>
                                                            </div>
                                                            <div className="clearfix"></div>
                                                            <div className="seria_info">
                                                                {track.artist && <a style={{color: "#000"}} href="/ru/singer/view/1">{track.artist.full} </a>}
                                                            </div>
                                                            <NavLink style={{whiteSpace: "nowrap"}} to={"/festival/" + transliterate(track.name) + "/" + track.media_id} className="title" title={track.name}>
                                                                {track.name} 
                                                            </NavLink>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                    {this.state.tracks.length > 0 && <Pagination currentPage={this.state.currentPage} totalPages={this.state.totalPages} onChange={this.onPageChange} />}
                                </div>
                            </div>
                            <div className="col-md-4 col-xs-12">
                                <div className="right_side">
                                    <div className="widget">
                                        <div className="title mb-5px">{t("Популярные фестивали")}</div>
                                        <div className="rayting-box">
                                            <a onClick={() => {
                                                this.onChangePeriod(EPeriod.DAY);
                                            }} className={this.state.period == EPeriod.DAY ? "active" : ""}>{t("День")}</a>
                                            <a onClick={() => {
                                                this.onChangePeriod(EPeriod.WEEK);
                                            }} className={this.state.period == EPeriod.WEEK ? "active" : ""}>{t("Неделя")}</a>
                                            <a onClick={() => {
                                                this.onChangePeriod(EPeriod.MONTH);
                                            }} className={this.state.period == EPeriod.MONTH ? "active" : ""}>{t("Месяц")}</a>
                                        </div>
                                        
                                        {this.state.isPopularLoading && <div className="carousel-placeholder"/>}
                                        {!this.state.isPopularLoading && <ul className={"music_l rayting-list " + (this.state.showMore ? 'scroll' : '')}>
                                            {/* <!--scroll class can be added to scroll--> */}
                                            {this.state.popularTracks.map((track: IMedia, index: number) => {
                                                if (!this.state.showMore && index > 10) return;

                                                return <li key={index}>
                                                    <a href={`${config.site}/site/upload/${track.media_id}?type=download`} className="down">
                                                        <img src="/img/download.png" alt={track.name} />
                                                        {track.download}
                                                    </a>
                                                    <div className="name">
                                                        <NavLink to={"/festival/" + transliterate((track.artist ? track.artist.full  + "-" : "") + track.name) + "/" + track.media_id}>
                                                            <b>{track.name}</b>
                                                        </NavLink>
                                                        {track.artist && <a href="/ru/singer/view/665">{track.artist.full}</a>}
                                                    </div>
                                                </li>
                                            })}
                                            {!this.state.isPopularLoading && this.state.popularTracks.length == 0 && <li className="text-center">{t("Ничего не найдено")}</li>}
                                        </ul>}
                                        {!this.state.isPopularLoading && this.state.popularTracks.length > 0 && <div className="text-center">
                                            <a onClick={() => {
                                                this.setState({
                                                    showMore: !this.state.showMore
                                                });
                                            }}>{this.state.showMore ? t("Показать меньше") : t("Показать больше")}</a>
                                        </div>}
                                    </div>
                                    <div className="banner235"></div>
                                    <div className="banner235"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(undefined)(withTranslation()(Festival));